import React from 'react';
import {Button} from '@goguardian/based';

import style from './style.scss';

export default class ThankYouOther extends React.Component {
  download() {
    window.open(`${process.env.static}/pdfs/guides/gg-17-18-product-booklet.pdf`, '_blank');
  }

  render() {

    return (
      <div className={style.tyContainer}>
        <h1>Thanks for your interest!</h1>
        <p>Your school's tech admin needs to give you access to a free trial. Here's some more information to share with them.</p>
        <p>We're excited to become a part of your classroom!</p>

        <Button onClick={this.download}>
          Download product guide
        </Button>
      </div>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/app/components/thankYou/other.jsx
 **/